import { FunctionComponent } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { Location } from "@App/Pages/Common/Location";
import { Brands } from "@App/Pages/Common/Brands";
import { KeyNumber } from "@App/Pages/Common/KeyNumber";
import { Generations } from "@App/Pages/Common/Generations";
import { Motorizations } from "@App/Pages/Common/Motorizations";
import { useServiceFunnel } from "@App/hooks/useServiceFunnel";

/**
 * The funnel for the starter battery service.
 *
 * @constructor
 */
export const StarterBattery: FunctionComponent = () => {
  const { navigateWithQuery } = useServiceFunnel("starterbatterie-erneuern");

  return (
    <Routes>
      <Route
        path={"/"}
        element={
          <Brands
            headline={"Batteriewechsel"}
            step={1}
            maxSteps={5}
            onKeyNumberLinkClick={() => navigateWithQuery("hsn-tsn")}
            onSubmit={() => navigateWithQuery(`modell`)}
          />
        }
      />
      <Route
        path={"/modell"}
        element={
          <Generations
            headline={"Batteriewechsel"}
            step={2}
            maxSteps={5}
            onKeyNumberLinkClick={() => navigateWithQuery("hsn-tsn")}
            onSubmit={() => navigateWithQuery(`../motorisierung`, true)}
          />
        }
      />
      <Route
        path={"/motorisierung"}
        element={
          <Motorizations
            headline={"Batteriewechsel"}
            step={3}
            maxSteps={5}
            onKeyNumberLinkClick={() => navigateWithQuery("hsn-tsn")}
            onSubmit={() => navigateWithQuery(`../ort`, true)}
          />
        }
      />
      <Route
        path={"/hsn-tsn"}
        element={
          <KeyNumber
            headline={"Batteriewechsel"}
            step={3}
            maxSteps={5}
            onVehicletreeLinkClick={() => navigateWithQuery("./")}
            onSubmit={() => navigateWithQuery(`../ort`, true)}
          />
        }
      />
      <Route
        path={"/ort"}
        element={
          <Location
            headline={"Batteriewechsel"}
            step={4}
            maxSteps={5}
            onSubmit={() => navigateWithQuery(`../werkstaetten`, true)}
          />
        }
      />
      {/* Redirect old links to funnel beginning */}
      <Route path={"/modellauswahl/*"} element={<Navigate to={"/starterbatterie-erneuern"} />} />
    </Routes>
  );
};
